import * as React from "react"
import Carousel from '../components/slider';
import { GatsbyImage } from "gatsby-plugin-image" 

class ImageCarouselWrapper extends React.Component {
  zoomCursor() {
    document.querySelector('.floating--cursor').classList.add('mouse-down');
  }
  resetCursor() {
    document.querySelector('.floating--cursor').classList.remove('mouse-down');
  }
  showCursor(e) {
    var title = e.currentTarget.getAttribute('data-cursor');
    if(title) {
      document.querySelector('.floating--cursor .caption .inner').innerHTML = title;
    }
    document.querySelector('.floating--cursor').classList.add('active');
  }
  showDragCursor() {
    document.querySelector('.floating--cursor').classList.add('active-drag');
  }
  hideCursor() {
    document.querySelector('.floating--cursor').classList.remove('active');
    document.querySelector('.floating--cursor').classList.remove('active-drag');
  } 
  render() { 
    const Slide = ({image, ratio}) => {
      return (
        <div className="flex carousel--image w-100 max-50vw pl30 pr30">
          <div className="max-550 w-100 ma">
            <div className="mousedown--zoom">
              <div className={ratio+" w-100 pos-rel pointer-none"}>
                <GatsbyImage image={image} alt="Carousel Image" className="bg-image" />  
              </div>
            </div>
          </div>
        </div> 
      )
    } 
    return (
      <>
        <div className="flex pl30 pr30 pb60 strong text-right"> 
          <p className="m0 align-self--bottom">Latest and Greatest</p> 
          <p className="m0 mla"><a className="link" rel="noreferrer" href="https://www.instagram.com/stemdesignflorals" target="_blank">Follow us<br/><span className="underline-link">@stemdesignflorals</span></a></p>
        </div>
        <div className="carousel--homepage text-center">
          <div className="image--carousel text-left fade-in" data-scroll role="presentation" onMouseEnter={this.showDragCursor} onFocus={this.showDragCursor} onBlur={this.hideCursor} onMouseLeave={this.hideCursor}>
            <Carousel 
              className="image-carousel"
              options={{
              pageDots: false,
              selectedAttraction: 0.04,
              wrapAround: true,
              friction: 0.8,
              freeScroll: true,
              freeScrollFriction: 0.06,
              contain: true,
              prevNextButtons: false,
              on: {
                pointerDown : this.zoomCursor,
                pointerUp : this.resetCursor,
              }
            }}>
              <Slide image={this.props.image1} ratio="ratio-2-1" />

              <Slide image={this.props.image2} ratio="ratio-1-1" />

              <Slide image={this.props.image3} ratio="ratio-2-1" />

              <Slide image={this.props.image4} ratio="ratio-1-1" />

            </Carousel> 
          </div>     
        </div>  
      </> 
    )
  }
} 

export default ImageCarouselWrapper

